'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.lookup.service
 * @description
 * # lookup.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('lookupService', function ($http, $q, BaseService, errorService) {

    var service = new BaseService();

    service.getBundles = getBundles;
    service.getScheduleUsers = getScheduleUsers;

    return service;

    function getBundles() {
      return $http.get(service.baseUrl + '/lookups/bundles/active')
      .then(handleSuccess)
      .catch(handleError);
    }

    function getScheduleUsers() {
      return $http.get(service.baseUrl + '/lookups/schedules/users')
      .then(handleSuccess)
      .catch(handleError);
    }

    function handleSuccess(response) {
      return response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }
  });
